<template>
    <div class="page-shelf-manage-edit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">後臺設置</div>
            <div class="breadcrumb-item">架號管理</div>
        </div>

        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Form :label-width="150">
                    <Row>
                        <Col span="11">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>貨架號</span>
                                </div>
                                <Input v-model="form.code"/>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>貨架類型</span>
                                </div>
                                <Select placeholder="請選擇" v-model="form.type">
                                    <Option :value="1">大</Option>
                                    <Option :value="2">中</Option>
                                    <Option :value="3">小</Option>
                                </Select>
                            </FormItem>
                        </Col>

                        <Col span="11">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>數量</span>
                                </div>
                                <Input v-model="form.count"/>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>門店</span>
                                </div>
                                <Select placeholder="請選擇" v-model="form.store_id">
                                    <Option :value="item.ReceivingID" v-for="(item, index) in shopList"
                                            :key="item.ReceivingID">{{item.ReceivingName}}
                                    </Option>
                                </Select>
                            </FormItem>
                        </Col>
                    </Row>

                    <div class="pg-btn-wrap" style="text-align: center;">
                        <div class="pg-btn style1" @click="handleCheckForm">確定</div>
                        <div class="pg-btn" @click="handleBack">返回</div>

                        <!--<Button type="error" :loading="true" class="loading-btn">
                            <span>Loading...</span>
                        </Button>-->
                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                pageParam: {},
                shopList: [],
                form: {
                    code: '',    //货架号
                    count: '',  //存放数量
                    type: '',   //货架类型 1大, 2中, 3小
                    store_id: '',   //门店id
                },
                isSubmiting: false,
            };
        },
        mounted()
        {
            this.pageParam = this.$route.query;
            this.getShopList();
            this.getDetail();
        },
        methods: {
            handleBack()
            {
                this.$router.go(-1);
            },
            //获取门店
            getShopList()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.pickAddress,
                    method: 'get',
                    data: {
                        company_id: 1,
                        type: 1    //type 1門店， 2是智能櫃
                    }
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.shopList = res.data.data;
                    }
                });
            },

            getDetail()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.shelvesDetail + '/' + this.pageParam.id,
                    method: 'get'
                }).then((res) => {
                    if (res.code == 0) {
                        let resData = res.data;
                        this.form = {
                            code: resData.code,    //货架号
                            count: resData.count,  //存放数量
                            type: resData.type,   //货架类型 1大, 2中, 3小
                            store_id: resData.store_id,   //门店id
                        }
                    }
                });
            },

            handleCheckForm()
            {
                let form = this.form;
                if (form.code === '')
                {
                    this.$Utils.showTipInfo('請輸入貨架號');
                    return;
                } else if (form.count === '')
                {
                    this.$Utils.showTipInfo('請輸入数量');
                    return;
                } else if (form.type === '')
                {
                    this.$Utils.showTipInfo('請选择货架类型');
                    return;
                } else if (form.store_id === '')
                {
                    this.$Utils.showTipInfo('請选择门店');
                    return;
                }

                this.handleSubmit();
            },
            handleSubmit()
            {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                    url: this.$Api.shelvesUpdate + '/' + this.pageParam.id,
                    method: 'post',
                    data: {
                        code: form.code,
                        count: form.count,
                        type: form.type,
                        store_id: form.store_id
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;

                    if (res.code == 0)
                    {
                        this.$Utils.showSuccess(res.msg);
                    } else
                    {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "ShelfManageEdit.scss";
</style>